import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tibao-1-jgd",
  "use": "icon-tibao-1-jgd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tibao-1-jgd\"><defs><style></style></defs><path d=\"M384 384h256v64H384zm160 459.584h-64V928H320v64h384v-64H544z\" /><path d=\"M512 32c-212.064 0-384 171.936-384 384s171.936 384 384 384 384-171.936 384-384S724.064 32 512 32zm0 704c-176.736 0-320-143.264-320-320S335.264 96 512 96s320 143.264 320 320-143.264 320-320 320z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol